import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  ChooseLanguageWrapper
} from './styled'

export class ChooseLanguage extends React.PureComponent {
  render () {
    const {
      className,
      type,
      id,
      name,
      value,
      checked,
      onChange,
      srcFlag,
      label
    } = this.props

    // props for css classes
    const classes = ClassNames(
      'choose-language',
      className
    )

    return (
      <ChooseLanguageWrapper
        className={classes}
      >
        <div className='choose-language-input-container'>
          <div className='choose-language-flag'>
            <img className='choose-language-flag-image'
              src={srcFlag}
              alt='Flag'
            />
          </div>
          <input
            className='choose-language-input'
            type={type}
            id={id}
            name={name}
            value={value}
            checked={checked}
            onChange={onChange}
          />
          <div className='choose-language-label'>
            {label}
          </div>
        </div>
      </ChooseLanguageWrapper>
    )
  }

  static defaultProps = {
    type: 'radio'
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
    className: PropTypes.string
  }
}
